function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 5H5C4 5 3 6 3 7V21C3 22.1 3.9 23 5 23H23C24 23 25 22 25 21V7C25 6 24 5 23 5ZM23 20.92C22.9861 20.9409 22.9624 20.9618 22.9426 20.9794C22.9339 20.987 22.9261 20.9939 22.92 21H5V7.08L5.08 7H22.91C22.9309 7.01394 22.9518 7.03761 22.9694 7.05744C22.977 7.06605 22.9839 7.07394 22.99 7.08V20.92H23Z",
  fill: "#808080"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4 13.6536C18.6667 13.8076 18.6667 14.1925 18.4 14.3464L12.1 17.9837C11.8333 18.1377 11.5 17.9452 11.5 17.6373L11.5 10.3627C11.5 10.0548 11.8333 9.86232 12.1 10.0163L18.4 13.6536Z",
  fill: "#808080"
});

var SvgIcVideos = function SvgIcVideos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVideos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_videos.fb55bec6.svg";
export { ForwardRef as ReactComponent };